import { Button } from "@/components/ui/button";

import type { GameType } from "../../types";
import Card from "./card";

interface ListProps {
  games: GameType[];
  onView(): void;
}

export default function List({ games, onView }: ListProps) {
  return (
    <div className="relative p-4 md:hidden">
      <Button
        className="absolute -top-11.5 left-1/2 h-7 -translate-x-1/2 rounded-[14px] bg-white px-3.5 font-normal text-12 text-byzantium"
        onClick={onView}
      >
        Map
      </Button>
      <div className="flex flex-col items-stretch *:not-first:mt-2.5 *:not-first:border-white/8 *:not-first:border-t *:not-first:pt-2.5">
        {games.map((game) => (
          <Card game={game} key={game.id} />
        ))}
      </div>
    </div>
  );
}
